//定义window全局变量用于传值，制图工程相关都放在drawmap下，
import commonTool from "../../../assets/js/global_tool/sys_tool/common_tool";
window.sys_mapping_system_prefix = "sys_mapping_system_"/*变量前缀*/

var domain='http://gykj123.cn:9035';
var baseURL=domain+'/api/v1';
var baseMapURL = 'http://gykj123.cn:9035/omap-baseserver/api/v1';//数据编辑模块行政区查询的api

window.drawmap={
  map:"",//地图对象
  mapStyle:"",//地图样式,
  username:commonTool.get_user_info().user_name,/*用户名*/
  token:"eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VybmFtZSI6ImFkbWluYmlnZGF0YSIsInN1YiI6ImFkbWluIiwiY29udGV4dFVzZXJJZCI6IjAiLCJjb250ZXh0TmFtZSI6IuefoumHj-WcsOWbvuacjeWKoSIsImNvbnRleHREZXB0SWQiOiIxIiwiY29udGV4dEFwcGxpY2F0aW9uSWQiOiIwIiwiaWF0IjoxNjE5Mzk3Njc2LCJleHAiOjE2MTk2NTY4NzZ9.2v8REvXceTaVTZ5HBiaTX5twvvQzD7d-wYgRI9Lrp9A",
  srid:"",/*坐标系,用于数据源过滤*/

  SERVER_API:{
    baseMapURL:baseMapURL,
    domain: domain,
    base: baseURL,
    users: baseURL + '/users',
    styles: baseURL + '/styles',
    tilesets: baseURL + '/tilesets',
    datasets: baseURL + '/datasets',
    fonts: baseURL + '/fonts',
    sprites: baseURL + '/sprites',
    uploads: baseURL + '/uploads',
    stats: baseURL + '/stats',
    templates: baseURL + '/templates',
    tilecopy: baseURL + '/tilecopy',
    tilegrid: baseURL + '/tilecopy/modify/tiles',
    tiletasks: baseURL + '/tiletasks',
    multitiler:baseURL + '/tiler/multi'
  }
};



// WEBPACK FOOTER //
// ./src/assets/js/global_tool/map_global.js